import component from "./component";
import IntervalPromise from "./interval-promise/IntervalPromise";
import TimeSinceFormatter from "./time-since-formatter/TimeSinceFormatter";
import Router from "./router/Router";
import * as env from "./environment";
// TODO: figure out why adding enzyme as a dependency in package.json results in errors when webpack:prod builds

const util = {
  component,
  intervalPromise: IntervalPromise,
  timeSinceFormatter: TimeSinceFormatter,
  router: Router,
  env,
};

export default util;
